import { Component } from '@angular/core';

@Component({
	selector: 'app-not-found-page',
	templateUrl: './not-found.page.html',
	styleUrl: './not-found.page.scss',
	standalone: true
})
export class NotFoundPage {

}
